









































import { Vue, Component, Prop } from "vue-property-decorator";
import FileItem from "./FileItem.vue";
import { ClientFormData, EContentType } from "@/types";

@Component({
  name: "field-item",
  components: {
    FileItem,
  },
})
export default class FieldItem extends Vue {
  @Prop({ type: Object, default: () => ({}) }) data!: ClientFormData;

  onClickFile(fileUrl: string) {
    this.$emit("onClickFile", fileUrl, this.data.label);
  }

  get isFileType(): boolean {
    return this.data.type === EContentType.FILE;
  }
}
